import { XERO_TRACKING_CATEGORY } from "constants/actionTypes";

import { serializeXeroTrackingCategory } from "lib/serializers/xeroTrackingCategories";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";
import { URLCreatorProps } from "./types";

function urlCreator(props: URLCreatorProps = {}): string {
  const { id, action } = props;
  return urlCheckAndAddIdAndAction("/v2/xero/tracking-categories/", id, action);
}

export const XeroTrackingCategoryAction = offlineActionCreator(
  XERO_TRACKING_CATEGORY,
  serializeXeroTrackingCategory,
  urlCreator,
  false,
);
